import { cn } from '@repo/lib/cn';

import { Badge } from '@/components/ui/badge';

interface QuestionCardProps {
  questionIndex: number;
  className?: string;
}

export default function QuestionCard(questionCardProps: QuestionCardProps) {
  const { questionIndex, className, ...props } = questionCardProps;

  return (
    <div
      tabIndex={0}
      className={cn('border-border-primary bg-fill-primary hover:bg-fill-primary-hover cursor-pointer overflow-hidden rounded-md border p-2 transition-colors select-none', className)}
      {...props}
    >
      <div className="flex items-center gap-2">
        <Badge variant={'muted'} size={'sm'} className="shrink-0">
          {questionIndex + 1}
        </Badge>
        <p className="text-text-secondary truncate text-sm font-medium">Pytanie {questionIndex + 1}</p>
      </div>
    </div>
  );
}
